var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E8F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6665C15.4545 22.6665 14.9335 22.4464 13.8913 22.0062C11.2971 20.9103 10 20.3624 10 19.4407C10 19.1826 10 14.7095 10 12.6665M16 22.6665C16.5455 22.6665 17.0665 22.4464 18.1087 22.0062C20.7029 20.9103 22 20.3624 22 19.4407V12.6665M16 22.6665V15.5697",
    stroke: "#2E77D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5506 14.4611L11.6031 13.5187C10.5344 13.0016 10 12.743 10 12.3335C10 11.924 10.5344 11.6654 11.6031 11.1483L13.5506 10.2059C14.7525 9.6243 15.3535 9.3335 16 9.3335C16.6465 9.3335 17.2475 9.6243 18.4494 10.2059L20.3969 11.1483C21.4656 11.6654 22 11.924 22 12.3335C22 12.743 21.4656 13.0016 20.3969 13.5187L18.4494 14.4611C17.2475 15.0427 16.6465 15.3335 16 15.3335C15.3535 15.3335 14.7525 15.0427 13.5506 14.4611Z",
    stroke: "#2E77D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L13.3333 16.6667",
    stroke: "#2E77D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 10.6665L12.6667 13.9998",
    stroke: "#2E77D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipBox);
export default __webpack_public_path__ + "static/media/shipBox.dca29687303f6ec503a6da752535255b.svg";
export { ForwardRef as ReactComponent };